export const COLUMN_WIDTHS = {
  ACCOUNT: 180,
  CREATED_BY: 120,
  CREATED_DATE: 140,
  INDUSTRY: 150,
  NAME: 500,
  WEB_ADDRESS: 250,
};
